<div class="component-wrapper">
  <mojo-pipeline-filters
    (changeFilterParams)="applyFilters($event)"
    (changeJobStatus)="changeJobStatus($event)"
    [selectedDepartment]="mapFunctionOrDepartment(true)"
    [selectedFunction]="mapFunctionOrDepartment(false)"
    [jobStatus]="params.status"
    (changeCandidateOrHiringManager)="changeCandidateOrHiringManager($event)"
  >
  </mojo-pipeline-filters>
</div>

<div class="component-wrapper">
  <mojo-pipeline-bar-charts></mojo-pipeline-bar-charts>
</div>

<div class="component-wrapper">
  <mojo-pipeline-jobs-list
    [pipelineAllActiveJobs]="selectAllActiveJobs$ | async"
    (reloadList)="changePage($event)"
  >
  </mojo-pipeline-jobs-list>
</div>
